// extracted by mini-css-extract-plugin
export default {"logo":"RegisterForm_logo__wqsRO","input":"RegisterForm_input__FsgBz"};